import * as React from "react";
const LightningIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.66674 1.33331L2.72904 8.45855C2.4965 8.73759 2.38023 8.87712 2.37846 8.99495C2.37691 9.09739 2.42256 9.19485 2.50224 9.25924C2.5939 9.33331 2.77552 9.33331 3.13876 9.33331H8.00007L7.3334 14.6666L13.2711 7.54141C13.5036 7.26236 13.6199 7.12284 13.6217 7.00501C13.6232 6.90257 13.5776 6.80511 13.4979 6.74072C13.4062 6.66665 13.2246 6.66665 12.8614 6.66665H8.00007L8.66674 1.33331Z"
      stroke="currentColor"
      strokeWidth={1.2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default LightningIcon;
